export const Basemap = {
  SATTELLITE: 'mapbox://styles/mapbox/satellite-streets-v12',
  STREETS: 'mapbox://styles/mapbox/streets-v11',
  LIGHT: 'mapbox://styles/mapbox/light-v10',
  DARK: 'mapbox://styles/mapbox/dark-v10',
  OUTDOORS: 'mapbox://styles/mapbox/outdoors-v11',
  SATELLITE_STREETS: 'mapbox://styles/mapbox/satellite-streets-v11',
  NAVIGATION_PREVIEW_DAY: 'mapbox://styles/mapbox/navigation-preview-day-v4',
  NAVIGATION_PREVIEW_NIGHT: 'mapbox://styles/mapbox/navigation-preview-night-v4',
  NAVIGATION_GUIDANCE_DAY: 'mapbox://styles/mapbox/navigation-guidance-day-v4',
  NAVIGATION_GUIDANCE_NIGHT: 'mapbox://styles/mapbox/navigation-guidance-night-v4',
};

export const MapTilerLayers = {
  BRIGHT: {
    url: 'https://api.maptiler.com/maps/bright-v2/style.json?key=zpcBwomuvc9uX1WpqIPt',
    name: 'Bright',
    description: 'General shiny map for context or navigation',
    name_vi: 'Sáng',
    description_vi: '',
  },
  STREETS: {
    url: 'https://api.maptiler.com/maps/streets-v2/style.json?key=zpcBwomuvc9uX1WpqIPt',
    name: 'Streets',
    description: 'Complete and legible map for navigation and mobility',
    name_vi: 'Đường phố',
    description_vi: 'Complete and legible map for navigation and mobility',
  },
  SATELLITE: {
    url: 'https://api.maptiler.com/maps/satellite/style.json?key=zpcBwomuvc9uX1WpqIPt',
    name: 'Satellite',
    description: 'Seamless satellite and aerial imagery of the world',
    name_vi: 'Vệ tinh',
    description_vi: 'Seamless satellite and aerial imagery of the world',
  },
  OSM: {
    url: 'https://api.maptiler.com/maps/openstreetmap/style.json?key=zpcBwomuvc9uX1WpqIPt',
    name: 'OpenStreetMap',
    description: 'OpenStreetMap map',
    name_vi: 'OpenStreetMap',
    description_vi: 'OpenStreetMap map',
  },
  LANDSCAPE: {
    url: 'https://api.maptiler.com/maps/landscape/style.json?key=zpcBwomuvc9uX1WpqIPt',
    name: 'Landscape',
    description: 'Light terrain map for data overlays and visualisations',
    name_vi: 'Landscape',
    description_vi: 'Light terrain map for data overlays and visualisations',
  },
  TONER: {
    url: 'https://api.maptiler.com/maps/toner-v2/style.json?key=zpcBwomuvc9uX1WpqIPt',
    name: 'Toner',
    description: 'Contrasted monochrome map for general use',
    name_vi: 'Toner',
    description_vi: 'Contrasted monochrome map for general use',
  },
  TOPO: {
    url: 'https://api.maptiler.com/maps/topo-v2/style.json?key=zpcBwomuvc9uX1WpqIPt',
    name: 'Topo',
    description: 'General topographic map for terrain and nature apps',
    name_vi: 'Topo',
    description_vi: 'General topographic map for terrain and nature apps',
  },
};

export const GoogleLayers = {
  ROADMAP: 'https://mt0.google.com/vt/lyrs=m&hl=en&x={x}&y={y}&z={z}',
  TERRAIN: 'https://mt0.google.com/vt/lyrs=p&hl=en&x={x}&y={y}&z={z}',
  ALTERED_ROADMAP: 'https://mt0.google.com/vt/lyrs=r&hl=en&x={x}&y={y}&z={z}',
  SATELLITE_ONLY: 'https://mt0.google.com/vt/lyrs=s&hl=en&x={x}&y={y}&z={z}',
  TERRAIN_ONLY: 'https://mt0.google.com/vt/lyrs=t&hl=en&x={x}&y={y}&z={z}',
  HYBRID: 'https://mt0.google.com/vt/lyrs=y&hl=en&x={x}&y={y}&z={z}',
};

export const MapLayers = {
  COLLECT_ITEM: 'collectItemSource',
};
